import OrderBilling from '@screens/order/billing'

export default function OrderBillingPage() {
  return <OrderBilling />
}
